import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'polpo-legals-page-terms-of-use',
  templateUrl: './legals-page-terms-of-use.component.html',
})
export class LegalsPageTermsOfUseComponent {}
